export default {
  partners: {
    en: 'Partners',
    fr: 'Partenaires',
  },
};
